// extracted by mini-css-extract-plugin
export var cgFooterHuge = "Footer-module--cg-footer-huge--997bd";
export var company = "Footer-module--company--3345a";
export var copyright = "Footer-module--copyright--4b9f0";
export var developers = "Footer-module--developers--1ff34";
export var employers = "Footer-module--employers--f1e7b";
export var logo = "Footer-module--logo--a1cb2";
export var socialNetwork = "Footer-module--social-network--94e30";
export var socialNetworkIcon = "Footer-module--social-network-icon--26fd5";
export var socialNetworks = "Footer-module--social-networks--79bfa";
export var svg = "Footer-module--svg--ae74f";